import { Injectable, Signal } from '@angular/core';
import { BaseFacade, Filter, Pagination } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import { UserApiKeysActions } from '../actions';
import { UserApiKeysSelectors } from '../selectors';
import { UserApiKey } from '@iot-platform/models/i4b';

/* eslint-disable @angular-eslint/prefer-inject */
@Injectable({
  providedIn: 'root'
})
export class UserApiKeysFacade extends BaseFacade<UserApiKey, Pagination, Filter> {
  userApiKeys: Signal<UserApiKey[]> = this.store.selectSignal(this.selector.selectAll);

  constructor(
    protected store: Store,
    protected selector: UserApiKeysSelectors
  ) {
    super(store, selector);
  }

  getAll() {
    noop();
  }

  setFilters(): void {
    noop();
  }

  loadUserApiKeys(userId: string): void {
    this.store.dispatch(UserApiKeysActions.loadUserApiKeys({ userId }));
  }

  createUserApiKey(userId: string, userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.createUserApiKey({ userId, userApiKey }));
  }

  editUserApiKey(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.editUserApiKey({ userApiKey }));
  }

  enableUserApiKey(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.enableUserApiKey({ userApiKey }));
  }

  disableUserApiKey(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.disableUserApiKey({ userApiKey }));
  }

  renewUserApiKey(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.renewUserApiKey({ userApiKey }));
  }

  manageUserApiKeyUsagePlan(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.manageUserApiKeyUsagePlan({ userApiKey }));
  }

  deleteUserApiKey(userApiKey: UserApiKey): void {
    this.store.dispatch(UserApiKeysActions.deleteUserApiKey({ userApiKey }));
  }
}
